// Shared customization options for Kai.

export const BACKGROUNDS = [
  { id: "void", name: "Vacío", style: "radial-gradient(ellipse 60% 50% at 50% 40%, rgba(0,240,255,0.08), transparent 70%), radial-gradient(ellipse 80% 60% at 50% 100%, rgba(0,51,255,0.06), transparent 70%), #020617" },
  { id: "nebula", name: "Nebulosa", style: "radial-gradient(ellipse at 28% 18%, rgba(168,85,247,0.20), transparent 60%), radial-gradient(ellipse at 82% 82%, rgba(34,211,238,0.16), transparent 60%), #0a0118" },
  { id: "abyss", name: "Abismo", style: "radial-gradient(ellipse at 50% 0%, rgba(14,116,233,0.22), transparent 65%), #00040f" },
  { id: "matrix", name: "Matrix", style: "radial-gradient(ellipse at 50% 30%, rgba(16,185,129,0.16), transparent 65%), #010a06" },
  { id: "ember", name: "Brasa", style: "radial-gradient(ellipse at 50% 92%, rgba(255,184,0,0.18), transparent 60%), radial-gradient(ellipse at 50% 8%, rgba(239,68,68,0.10), transparent 60%), #0c0600" },
  { id: "steel", name: "Acero", style: "linear-gradient(160deg, #131c2e, #020617 70%)" },
];

export const getBackgroundStyle = (id) =>
  (BACKGROUNDS.find((b) => b.id === id) || BACKGROUNDS[0]).style;

export const PERSONALITIES = [
  { id: "sarcastic", name: "Sarcástico (JARVIS)", desc: "Ingenio seco e ironía elegante, siempre útil." },
  { id: "professional", name: "Profesional", desc: "Tono neutro, sobrio y directo." },
  { id: "friendly", name: "Cercano", desc: "Cálido y alentador, sin perder elegancia." },
  { id: "concise", name: "Conciso", desc: "Respuestas breves y directas." },
  { id: "custom", name: "Personalizado", desc: "Define tú mismo su personalidad." },
];

export const DEFAULT_PREFERENCES = {
  background: "void",
  personality: "sarcastic",
  custom_personality: "",
  voice_enabled: true,
  continuous_listening: true,
};
